import React, { useEffect, useRef } from "react";
import { AiOutlineSearch } from "react-icons/ai";
import "./SearchInput.css";
import { CommandShortcut } from "../CommandShortcut/CommandShortcut";
import Loader from "../Loader/Loader";

const SearchInput = (props) => {
	const ref = useRef();

	useEffect(() => {
		function commandHandler(e) {
			if (e.altKey && e.key === "k") {
				if (ref.current === document.activeElement) {
					ref?.current.blur();
					return;
				}
				ref?.current.focus();
			}
		}
		document.addEventListener("keyup", commandHandler);
		return () => document.removeEventListener("keyup", commandHandler);
	})

	return (
		<div>
			{props.value ? (
				<span style={{ color: "var(--text-color" }}>
					{/* Pressione ENTER para buscar */}
				</span>
			) : (
				""
			)}
			<div style={{ display: "flex", alignItems: "center", position: "relative" }}>
				<input
					ref={ref}
					name={props.name}
					value={props.value || ""}
					placeholder={props.placeholder}
					className={"input-form search-input"}
					onChange={props.onChange}
					onKeyDown={props.onKeyPress}
					type={props.type || "text"}
					required={props.required || false}
					disabled={props.disabled || false}
					style={{
						backgroundColor: props.disabled
							? "var(--inputBackgroundColorDisabled)"
							: "var(--inputBackgroundColor)",
					}}
				/>
				<div
					style={{
						position: "absolute",
						top: "50%",
						transform: "translateY(-50%)",
						right: "10px",
						height: "17px",
						display: "flex",
						alignItems: "center",
						gap: "10px"
					}}
				>
					{!props.value && (
						<CommandShortcut>
							Alt+K
						</CommandShortcut>
					)}
					{props.isLoading ? (
						<Loader
							styles={{
								marginTop: "0",
							}}
							width={18}
							height={18}
						/>
					) : (
						<AiOutlineSearch size={17} color={"gray"} />
					)}
				</div>
			</div>
		</div>
	);
};

export default SearchInput;
